/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Control_Track_Fade_HelpInputs */



/**
* | output |
* | --- |
* | "How far downstream mixers lower the programme audio during each description." |
*
* @param {Audio_Description_Export_Control_Track_Fade_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_control_track_fade_help = /** @type {((inputs?: Audio_Description_Export_Control_Track_Fade_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Control_Track_Fade_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("De combien les mélangeurs en aval baissent le son du programme pendant chaque description.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie stark nachgelagerte Mischer den Programmton während jeder Beschreibung absenken.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Di quanto i mixer a valle abbassano l'audio del programma durante ogni descrizione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Насколько последующие микшеры приглушают звук программы во время каждого описания.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cuánto bajan los mezcladores posteriores el audio del programa durante cada descripción.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每段描述期间下游混音器将节目音频降低的幅度。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("各解説の間、後段のミキサーが番組音声をどれだけ下げるかを指定します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हर विवरण के दौरान डाउनस्ट्रीम मिक्सर प्रोग्राम ऑडियो को कितना कम करते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Quanto os misturadores a jusante baixam o áudio do programa durante cada descrição.")
	return /** @type {LocalizedString} */ ("How far downstream mixers lower the programme audio during each description.")
});